/**
 * Oficialūs reDevicer / Redevicer, UAB duomenys (Rekvizitai.vz.lt).
 * Atnaujinkite čia — naudojama footeryje, privatumo politikoje ir sąlygose.
 */
const PUBLIC_CONTACT_EMAIL = 'info@redevicer.com' as const

export const appLegalConfig = {
  appName: 'reDevicer',
  websiteUrl: 'https://www.redevicer.com',
  /** Palaikymas ir teisės klausimai ({{SUPPORT_EMAIL}} teisiniuose dokumentuose). */
  supportEmail: PUBLIC_CONTACT_EMAIL,
  infoEmail: PUBLIC_CONTACT_EMAIL,
  /** Anoniminis atsiliepimų klausimynas (Google Forms ir pan.). Jei tuščia — rodomas tik tekstas. */
  feedbackSurveyUrl: '',
  contactPhone: '+370 613 70777',
  workingHours: 'Pr.–Pt. 9:00–18:00',
  privacyPolicyWebUrl: '',
  termsWebUrl: '',
  /** Juridinio asmens pavadinimas (rodomas footeryje ir teisiniuose dokumentuose). */
  legalEntityName: 'reDevicer, UAB',
  companyCode: '307993792',
  shareCapital: '2 500 €',
  director: 'Patricija Taraškevičienė, direktorė',
  registeredAddress: 'Deltuvos g. 31-106, LT-08100 Vilnius',
  /** Tuščia, kol nėra PVM mokėtojo / sąskaitos — footeryje nerodoma. */
  vatCode: '',
  bankName: '',
  iban: '',
  governingLawCountry: 'Republic of Lithuania',
  minAgeYears: 16,
  legalLastUpdated: '2026-07-29',
} as const
